"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.TableFooter = void 0;
var react_1 = __importDefault(require("react"));
var i18n_1 = require("../../../i18n");
var styles_1 = require("../../../styles");
var HFlow_1 = require("../../HFlow");
var Number_1 = require("../../Number");
var Paginator_1 = require("../../Paginator/Paginator");
var Text_1 = require("../../Text");
var TableSizeDropdown_1 = require("./TableSizeDropdown");
function TableFooter(props) {
    var style = props.style, page = props.page, totalPages = props.totalPages, totalElements = props.totalElements, abbrev = props.abbrev, pageSize = props.pageSize, sizeOptions = props.sizeOptions, onSizeChange = props.onSizeChange, onPageChange = props.onPageChange;
    var _a = styles_1.useStyles(exports.createStyles), classes = _a.classes, css = _a.css;
    var locale = i18n_1.useLocale();
    var showPagination = function () {
        return totalElements > pageSize || totalElements > Math.min.apply(Math, sizeOptions);
    };
    return (react_1.default.createElement("div", { className: css(classes.footer, style) },
        react_1.default.createElement("span", { className: classes.results },
            react_1.default.createElement(Number_1.Number, { value: totalElements, suffix: " " + (totalElements === 0
                    ? locale.tableFooter.results.zero
                    : totalElements === 1
                        ? locale.tableFooter.results.one
                        : locale.tableFooter.results.other), abbrev: abbrev })),
        showPagination() && (react_1.default.createElement("div", { className: classes.pagination },
            react_1.default.createElement(HFlow_1.HFlow, { alignItems: 'center', hSpacing: 0.5 },
                react_1.default.createElement(Text_1.Text, null, "Mostrar:"),
                react_1.default.createElement(TableSizeDropdown_1.TableSizeDropdown, { options: sizeOptions, size: pageSize, onChange: onSizeChange })),
            react_1.default.createElement(Paginator_1.Paginator, { page: page, total: totalPages, onChange: onPageChange })))));
}
exports.TableFooter = TableFooter;
TableFooter.defaultProps = {
    sizeOptions: [10, 30, 50, 100],
};
exports.createStyles = function (theme) { return ({
    footer: {
        display: 'flex',
        alignItems: 'stretch',
        border: '1px solid ' + theme.pallete.divider,
        height: 40,
    },
    results: {
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        paddingRight: '1rem',
        paddingLeft: '1rem',
    },
    pagination: {
        borderLeft: '1px solid ' + theme.pallete.divider,
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        justifyContent: 'space-between',
        padding: '4px 1rem',
    },
}); };
//# sourceMappingURL=TableFooter.js.map